export const PDP_TOP_SIMILAR_ITEMS_COUNT = 6;
